import React from 'react';
import ReactDOM from 'react-dom';
import './styles/index.css';
import App from './App';
import { AppProvider } from './contexts/appcontext.js'
import { BrowserRouter } from 'react-router-dom'
ReactDOM.render(
  <>
    {/* <svg className="overlay" width="100%" height="100%" viewBox="0 0 100 100" preserveAspectRatio="none">
      <path className="overlay__path" vectorEffect="non-scaling-stroke" d="M 0 0 h 0 c 0 50 0 50 0 100 H 0 V 0 Z" />
    </svg> */}
    <BrowserRouter >
      <AppProvider>
        <App />
      </AppProvider>
    </BrowserRouter>
  </>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
